import React from "react";
import { Link } from "react-router-dom";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

import Badge from "components/Badge";

export interface CardProps {
  /** Omitted for a row the person may see but not open. */
  link?: string;
  name: string;
  subName?: string;
  badgeText: string;
}

const Card: React.FC<CardProps> = ({ link, name, subName, badgeText }) => {
  const row = (
    <div
      className={`px-5 py-4 transition-all duration-100 ${link ? "hover:bg-cantelope-light" : ""}`}
    >
      <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
        <div className="flex min-w-0 flex-col">
          <p className="break-words text-base font-bold text-soil">{name}</p>
          {subName && <p className="text-sm text-evergreen/80">{subName}</p>}
        </div>
        <div className="flex shrink-0 items-center gap-4">
          <Badge text={badgeText} />
          {link && (
            <div className="flex items-center gap-0">
              <p className="text-sm font-bold text-soil">Details</p>
              <ChevronRightIcon className="h-4 w-4 text-soil" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
  if (!link) return row;
  return (
    <Link to={link} className="block">
      {row}
    </Link>
  );
};

export default Card;
